import { render, staticRenderFns } from "./Episode5.vue?vue&type=template&id=3a1c2394&"
import script from "./Episode5.vue?vue&type=script&lang=js&"
export * from "./Episode5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports